import { styled } from "goober";

export const FarmingContent = styled("div")`
  display: grid;
  gap: var(--sp-3);

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .legend {
    display: flex;
    align-items: center;
    gap: var(--sp-3);
  }
  .legend-item {
    display: flex;
    align-items: center;
    gap: var(--sp-1_5);

    .legend-dot {
      --color: var(--shade0);
      width: var(--sp-2_5);
      height: var(--sp-1_5);
      background: var(--color);
      border-radius: var(--br-sm);
    }
  }

  .buttons {
    button {
      background: transparent;
      opacity: 0.5;
      cursor: pointer;
      border-radius: var(--br-sm);

      &[data-active="true"] {
        opacity: 1;
        background: var(--shade1-15);
      }
    }
  }
`;
